const postUpdateGiveawayStockRequest = (formField) => {
  const payload = {
    briefGiveawaySessionId: formField?.briefGiveawaySessionId,
    note: formField?.note,
    usedStock: formField?.usedStock,
    imagePath: formField?.imagePath,
  };

  return payload;
};

export default postUpdateGiveawayStockRequest;
